<template>
    <div class="modal-card" style="width: auto">
        <section v-if="$store.state.search.maxMins.hasOwnProperty('ongoingchargemin')" class="modal-card-body">
            <div class="container is-max-tablet is-max-desktop is-max-fullhd">
                <div class="columns mt-5">
                    <div class="column is-12-tablet is-9-desktop">
                        <div id="filters" class="p-t-70">
                            <div class="is-flex is-align-items-center m-b-30 is-hidden-mobile">
                                <h2 class="title-filter has-text-weight-bold is-size-4-tablet is-size-5">Basic Filters</h2>
                            </div>
                            <div class="is-flex is-justify-content-center m-b-30 is-hidden-tablet">
                                <div class="is-flex is-size-6">
                                    <button class="filters-selected has-text-light" disabled>Basic Filters</button>
                                    <button class="filters-link" @click="switchIt()">Advanced Filters</button>
                                </div>
                            </div>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Sustainability.svg"> Sustainability
                                <!--<span>(4)</span>-->
                                <a class="clear-btn" @click="basic.esg=null, nonEsg=false">Clear</a></h3>
                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet is-flex sustainability">
                                        <b-checkbox v-model="basic.esg"><span class="font-medium-mobile">ESG</span></b-checkbox>
                                        <b-checkbox v-model="nonEsg"><span class="font-medium-mobile">Non ESG</span></b-checkbox>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Eligibility.svg"> Eligibility
                                <!--<span>(4)</span>--> <a class="clear-btn"
                                                        @click="basic.ISA=null,basic.SIPP=null">Clear</a></h3>
                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <b-checkbox v-model="basic.ISA"><span class="font-medium-mobile">ISA</span></b-checkbox>
                                        <b-checkbox v-model="basic.SIPP"><span class="font-medium-mobile">SIPP</span></b-checkbox>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Income_policy.svg"> Income policy
                                <!--<span>(4)</span>-->
                                <a class="clear-btn" @click="basic.physical=null">Clear</a></h3>
                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <label class="m-b-0-mobile">Type of Unit available</label>
                                        <div class="columns field field-radio m-t-5-mobile">
                                            <div class="column is-4-mobile">
                                                <b-radio v-model="basic.physical"
                                                        name="radio6"
                                                        size="is-small"
                                                        native-value="B">
                                                    All
                                                </b-radio>
                                            </div>
                                            <div class="column is-4-mobile">
                                                <b-radio v-model="basic.physical"
                                                        name="radio6"
                                                        size="is-small"
                                                        native-value="I">
                                                    Income
                                                </b-radio>
                                            </div>
                                            <div class="column is-4-mobile">
                                                <b-radio v-model="basic.physical"
                                                        name="radio6"
                                                        size="is-small"
                                                        native-value="A">
                                                    Accumulation
                                                </b-radio>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Broad.svg"> Broad
                                <!--<span>(4)</span>-->
                                <a class="clear-btn" @click="basic.etf=null,basic.fundtype='',basic.managementType='',basic.assetManager=[],basic.fundcategory=null, nonEtf=false">Clear</a></h3>
                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                           <div>
                                                <div class="is-flex etf-options">
                                                    <b-checkbox v-model="basic.etf">ETF</b-checkbox>
                                                    <b-checkbox v-model="nonEtf">Non ETF</b-checkbox>
                                                </div>
                                            <div>
                                                <label class="m-b-0-mobile">Fund Type</label>
                                                <div class="columns field field-radio m-t-0-mobile">
                                                    <div class="column is-4-mobile is-align-self-center">
                                                        <b-radio v-model="basic.fundtype"
                                                                name="radio1"
                                                                size="is-small"
                                                                native-value="">
                                                            All
                                                        </b-radio>
                                                    </div>
                                                    <div class="column is-4-mobile">
                                                        <b-radio v-model="basic.fundtype"
                                                                name="radio1"
                                                                size="is-small"
                                                                native-value="Open Ended">
                                                            Open Ended
                                                        </b-radio>
                                                    </div>
                                                    <div class="column is-4-mobile">
                                                        <b-radio v-model="basic.fundtype"
                                                                name="radio1"
                                                                size="is-small"
                                                                native-value="Closed Ended">
                                                            Closed Ended
                                                        </b-radio>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <label class="m-b-0-mobile">Style</label>
                                                <div class="columns field field-radio m-t-5-mobile">
                                                    <div class="column is-4-mobile">
                                                        <b-radio v-model="basic.managementType"
                                                                name="radio2"
                                                                size="is-small"
                                                                native-value="">
                                                            All
                                                        </b-radio>
                                                    </div>
                                                    <div class="column is-4-mobile">
                                                        <b-radio v-model="basic.managementType"
                                                                class="btn-active"
                                                                name="radio2"
                                                                size="is-small"
                                                                native-value="A">
                                                            Active
                                                        </b-radio>
                                                    </div>
                                                    <div class="column is-4-mobile">
                                                        <b-radio v-model="basic.managementType"
                                                                class="btn-passive"
                                                                name="radio2"
                                                                size="is-small"
                                                                native-value="P">
                                                            Passive
                                                        </b-radio>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="columns is-justify-content-center is-hidden-mobile">
                                    <div class="column is-11-tablet">
                                        <div class="select-wrapper select-wrapper-custom">
                                            <label>Asset Manager</label>
                                            <multiselect class="dropdown-customize" 
                                            :optionsLimit="2000" v-model="basic.assetManager" 
                                            :options="managersFilter" :multiple="true" placeholder="All"
                                            :max-height="600" :optionHeight="100" 
                                            :limit="40"
                                            >
                                                <template slot="tag" slot-scope="{ option, remove }">
                                                    <span class="multiselect__tag" v-tooltip="viewDetailOption(option)"><span>{{ option }}</span>
                                                    <i class="multiselect__tag-icon" @click="remove(option)"></i></span>
                                                </template>
                                            </multiselect>
                                            <div class="control select-all" @click="selectAllItems('asset-manager')"><a>Select all menu items</a></div>
                                        </div>
                                        <div class="select-wrapper select-wrapper-custom">
                                            <label>Fund Category</label>
                                            <multiselect class="dropdown-customize" :optionsLimit="2000" v-model="basic.fundcategory" :options="$store.state.search.categorySelection" :multiple="true" placeholder="All"></multiselect>
                                            <div class="control select-all" @click="selectAllItems('fund-category')"><a>Select all menu items</a></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="columns is-justify-content-center is-hidden-tablet">
                                    <div class="column is-11-tablet">
                                        <h3 class="has-text-weight-bold mb-5 m-b-10-mobile">
                                            <span class="font-large" style="font-weight: bold !important">Asset Manager</span> 
                                        <a @click="selectAllItems('asset-manager')">All but...</a>
                                        </h3>
                                        <div class="select-wrapper select-wrapper-custom pb-5">
                                            <multiselect class="dropdown-customize" :optionsLimit="2000" v-model="basic.assetManager" :options="managersFilter" :multiple="true"     placeholder="All"
                                            ></multiselect>
                                        </div>

                                        <h3 class="has-text-weight-bold mb-5 m-b-10-mobile">
                                            <span class="font-large" style="font-weight: bold !important">Fund Category</span> 
                                        <a @click="selectAllItems('fund-category')">All but...</a>
                                        </h3>
                                        <div class="select-wrapper select-wrapper-custom">
                                            <multiselect class="dropdown-customize" :optionsLimit="2000" v-model="basic.fundcategory" :options="$store.state.search.categorySelection" :multiple="true" placeholder="All"></multiselect>
                                        </div>
                                    </div>
                                </div>                             
                            </div>
                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Cost.svg"> Cost
                                <!--<span>(4)</span>-->
                                <a class="clear-btn" @click="cl1">Clear</a></h3>



                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <quantile
                                            v-on:slider-change="basic.ongoingchargecomp=$event"
                                            :arr="basic.ongoingchargecomp"
                                            :percentileType="'ongoingchargecomp'"
                                            :title="'Ongoing Charge'"
                                            :step="0.01"
                                            :fixed="2"
                                            :format="'percent'"
                                            :minLimit=parseFloat($store.state.search.maxMins.ongoingchargemin)
                                            :maxLimit=parseFloat($store.state.search.maxMins.ongoingchargemax)
                                            :smalltitle="false"
                                            :reverse="true"
                                            :clear="clearSlider1"
                                        ></quantile>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Return.svg"> return
                                <!--<span>(4)</span>-->
                                <a class="clear-btn" @click="cl2">Clear</a></h3>
                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">

                                        <label>Total Return Net of Fees</label>

                                        <quantile v-on:slider-change="basic.CumulativeTotalReturnTD=$event"
                                                :arr="basic.CumulativeTotalReturnTD"
                                                :percentileType="'CumulativeTotalReturnTD'"
                                                :title="'Year to Date'"
                                                :step="0.01"
                                                :fixed="2"
                                                :format="'percent'"
                                                :minLimit=parseFloat($store.state.search.maxMins.ctdmin)
                                                :maxLimit=parseFloat($store.state.search.maxMins.ctdmax)
                                                :smalltitle="true"
                                                :reverse="true"
                                                :clear="clearSlider2"></quantile>

                                        <hr>
                                        <quantile v-on:slider-change="basic.CumulativeTotalReturn1Y=$event"
                                                :arr="basic.CumulativeTotalReturn1Y"
                                                :percentileType="'CumulativeTotalReturn1Y'"
                                                :title="'1 Year'" :suffix="'%'"
                                                :minLimit=parseFloat($store.state.search.maxMins.min1)
                                                :maxLimit=parseFloat($store.state.search.maxMins.max1)
                                                :reverse="true"
                                                :step="0.01"
                                                :fixed="2"
                                                :format="'percent'"
                                                :smalltitle="true" :clear="clearSlider2"></quantile>

                                        <hr>
                                        <quantile v-on:slider-change="basic.TotalReturn3Years=$event" :title="'3 Year'"
                                                :arr="basic.TotalReturn3Years"
                                                :percentileType="'TotalReturn3Years'"
                                                :step="0.01"
                                                :fixed="2"
                                                :format="'percent'"
                                                :minLimit=parseFloat($store.state.search.maxMins.min3)
                                                :maxLimit=parseFloat($store.state.search.maxMins.max3)
                                                :smalltitle="true"
                                                :reverse="true"
                                                :clear="clearSlider2"></quantile>

                                        <hr>
                                        <quantile v-on:slider-change="basic.TotalReturn5Years=$event" :title="'5 Year'"
                                                :arr="basic.TotalReturn5Years"
                                                :percentileType="'TotalReturn5Years'"
                                                :step="0.01"
                                                :fixed="2"
                                                :format="'percent'"
                                                :minLimit=parseFloat($store.state.search.maxMins.min5)
                                                :maxLimit=parseFloat($store.state.search.maxMins.max5)
                                                :smalltitle="true"
                                                :reverse="true"
                                                :clear="clearSlider2"></quantile>

                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Risk.svg"> risk
                                <!--<span>(4)</span>-->
                                <a class="clear-btn" @click="basic.riskrating_6M=[]">Clear</a></h3>
                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    
                                </div>
                                <div class="columns is-justify-content-center pt-0 risk-indicator-wrap">
                                    <div class="column is-9-tablet pb-0">
                                        <div class="multicheck">
                                            <b-checkbox native-value="1" v-model="basic.riskrating_6M">1</b-checkbox>
                                            <b-checkbox native-value="2" v-model="basic.riskrating_6M">2</b-checkbox>
                                            <b-checkbox native-value="3" v-model="basic.riskrating_6M">3</b-checkbox>
                                            <b-checkbox native-value="4" v-model="basic.riskrating_6M">4</b-checkbox>
                                            <b-checkbox native-value="5" v-model="basic.riskrating_6M">5</b-checkbox>
                                        </div>
                                    </div>
                                    <div class="column is-9-tablet pt-0">
                                        <div class="risk-indicator">
                                            <div class="arrow-left"></div>
                                            <div class="line"></div>
                                            <div class="arrow-right"></div>
                                        </div>
                                    </div>
                                    <div class="column is-9-tablet">
                                        <div class="risk-indicator">
                                            <h3 class="has-text-weight-bold">Low</h3>
                                            <div class="line no-border"></div>
                                            <h3 class="has-text-weight-bold">High</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Other.svg"> OTHER
                                <!--<span>(4)</span>-->
                                <a class="clear-btn" @click="cl3">Clear</a></h3>
                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <quantile v-on:slider-change="basic.fundnetassetgbp=$event"
                                                :arr="basic.fundnetassetgbp"
                                                :percentileType="'fundnetassetgbp'"
                                                :title="'Net Assets'"
                                                :step="0.1"
                                                :fixed="1"
                                                :format="'pounds'"
                                                :minLimit=parseFloat($store.state.search.maxMins.netassetmin)
                                                :maxLimit=parseFloat($store.state.search.maxMins.netassetmax)
                                                :smalltitle="false"
                                                :nobuttons="true"
                                                :increaseButton="true"
                                                :increaseValue="10000000"
                                                :class="'increase-value'"
                                                :clear="clearSlider3"></quantile>

                                    </div>
                                </div>
                            </div>
                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <quantile v-on:slider-change="basic.yield12m=$event"
                                                :arr="basic.yield12m"
                                                :percentileType="'yield12m'"
                                                :title="'Yield'"
                                                :step="0.01"
                                                :fixed="2"
                                                :format="'percent'"
                                                :minLimit=parseFloat($store.state.search.maxMins.minyield)
                                                :maxLimit=parseFloat($store.state.search.maxMins.maxyield)
                                                :smalltitle="false"
                                                :nobuttons="true"
                                                :clear="clearSlider3"></quantile>
                                    </div>
                                </div>
                            </div>
    <!--
                            <pre>{{ basic }}{{$store.state.search.maxMins}}</pre>
    -->
                            <div class="popup-floating">
                                <div class="container is-max-tablet is-max-desktop is-max-fullhd">
                                    <div class="columns">
                                        <div class="column is-9-desktop px-4">
                                            <p class="my-3 is-size-6 ml-2"><strong>{{ calTotal }} of {{this.$store.state.search.searchData.total_search}} Funds</strong> </p>
                                            <div class="buttons ml-2">
                                                <button class="button is-secundary mr-3" @click="cleanAll">clear all</button>
                                                <button class="button is-primary mx-3" @click="submit(true)">Apply</button>
                                                <span class="is-hidden-mobile m-l-10-tablet">
                                                    <page-help :height="'560px'" :pageHelp="'filters'"/>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- <div class="column is-3-desktop m-t-100-desktop">
                        <div class="ad">
                            <h2>AD</h2>
                        </div>
                        <div class="ad mt-4">
                            <h2>AD</h2>
                        </div>
                    </div> -->

                </div>
            </div>
        </section>
        <footer class="modal-card-foot has-text-right  p-t-0 p-r-0 p-b-0 p-l-0">
            <button @click="confirm()" class="button is-primary is-fullwidth">Close Filters</button>
        </footer>
    </div>
</template>
<script>
import Quantile from "@/components/Quantile";
import {cats, catslist, shortlist} from "@/plugins/cats";
import Multiselect from 'vue-multiselect'
import PageHelp from '@/components/PageHelp.vue';

export default {
    name: 'Advancedfilter',
    components: {
        quantile: Quantile,
        Multiselect,
        PageHelp
    },
    props: {
        clean:Boolean,
        /*absoluteTotal:Number,
        newtotal:Number,
        filterReturned:Object,
        preFilterTotal:Number*/
    },
    data() {
        return {
            managerList:[],
            managersSelected:[],
            cats: catslist(),
            clearSlider1: false,
            clearSlider2: false,
            clearSlider3: false,
            basic: {
                esg: null,
                ISA: null,
                SIPP: null,
                physical: "B",
                etf: null,
                fundtype: "",
                managementType: "",
                assetManager: [],
                fundcategory: null,
                ongoingchargecomp: [],
                CumulativeTotalReturnTD: [],
                CumulativeTotalReturn1Y: [],
                TotalReturn3Years: [],
                TotalReturn5Years: [],
                riskrating_6M: [],
                fundnetassetgbp: [],
                yield12m: [],
            },
            smallShort: {},
            saveKeys: {},
            shortcutAssetManager: {},
            nonEsg: false,
            nonEtf: false
        }
    },
    computed:{

        calTotal(){
            if("total" in this.$store.state.search.provisionalSearch){
                return this.$store.state.search.provisionalSearch.total
            }
            else{
                return this.$store.state.search.searchData.total_search
            }
        },
        managersFilter(){
            let arr = []
            let obj = {};
            this.$store.state.search.managerSelection.forEach(element => {
                if (element.am_short !== null) {
                    arr.push(element.am_short)
                    obj[element.am_short]=element.CompanyBasicsName;
                }
            });
            Object.assign(this.shortcutAssetManager, obj);
            this.$store.commit("search/SET_SMALL_SHORT", this.shortcutAssetManager);
            return Array.from(new Set(arr))
        },
    },
    methods: {
        confirm() {
            this.$buefy.dialog.confirm({
                type: 'is-danger',
                hasIcon: true,
                message: 'Exit without saving changes?',
                onConfirm: () => this.closeMe()
            })
        },
        closeMe(){
            this.$store.commit("search/SET_PROV_FILTERS",this.$store.state.search.filters)
            //this.$store.commit("search/SET_PROV_FILTERS",)
            this.$emit('scrollPageToTopAfterFilter', true)
            this.$parent.close()
            this.$emit("working-filter", false)
        },
        catsArray() {
            return Object.keys(cats).map((key) => [key, cats[key]]);
        },
        catslist() {
            return catslist()
        },
        shortlist() {
              return shortlist()
        },
        cl1(){
            this.clearSlider1 = !this.clearSlider1;
            this.basic.ongoingchargecomp = []
        },
        cl2(){
            this.clearSlider2 = !this.clearSlider2;
            this.basic.CumulativeTotalReturnTD = []
            this.basic.CumulativeTotalReturn1Y = []
            this.basic.TotalReturn3Years = []
            this.basic.TotalReturn5Years = []
        },
        cl3(){
            this.clearSlider3 = !this.clearSlider3;
            this.basic.fundnetassetgbp = []
            this.basic.yield12m = []
        },

        cleanAll() {
            this.clearSlider1 = !this.clearSlider1;
            this.clearSlider2 = !this.clearSlider2;
            this.clearSlider3 = !this.clearSlider3;
            this.basic.esg = null
            this.basic.ISA = null
            this.basic.SIPP = null
            this.basic.physical = null
            this.basic.etf = null
            this.basic.managementType = ''
            this.basic.fundtype = ''
            this.basic.assetManager = []
            this.basic.fundcategory = null
            this.basic.ongoingchargecomp = []
            this.basic.CumulativeTotalReturnTD = []
            this.basic.CumulativeTotalReturn1Y = []
            this.basic.TotalReturn3Years = []
            this.basic.TotalReturn5Years = []
            this.basic.riskrating_6M = []
            this.basic.fundnetassetgbp = []
            this.basic.yield12m = []
            this.nonEtf = false;
            this.nonEsg = false;
        },
        switchIt(){
            this.$emit("switch-it")
            this.submit(false)
        },
        async submit(apply) {
            let saveKeys = this.saveKeys;
            Object.assign(saveKeys, this.saveKeys)
            this.saveKeys = {};
            for (let key of Object.keys(saveKeys)) {
                if (key == 'esg' || key == 'etf') {
                    if (this.basic[key] !== null) {
                        this.saveKeys[key] = this.basic[key];
                    }
                } else if(this.basic[key]) {
                    if(this.basic[key] !== 'B' && this.basic[key].length > 0 || this.basic[key] === true) {
                        this.saveKeys[key] = this.basic[key];
                    }
                }
            }
            this.$store.commit("search/SET_COUNT_BASIC", Object.keys(this.saveKeys).length)
            //this.$emit("search-filter", this.basic)
            this.$emit('checkBasicFilterShowAll', this.basic);
            this.$emit("working-filter", false);

            this.$store.commit("search/SET_FILTERS", {...this.basic, count_filters_basic: Object.keys(this.saveKeys).length})
            if (apply) {
                await this.$store.dispatch("search/apiCall", this.$store.state.search.lastSearch)
                this.$emit('scrollPageToTopAfterFilter', true)
                this.$parent.close()
            }
        },
        selectAllItems(type) {
            switch (type) {
                case 'asset-manager':
                    this.basic.assetManager = this.managersFilter;
                    break;
                
                case 'fund-category':
                    this.basic.fundcategory = this.$store.state.search.categorySelection;
                    break;

                default:
                    break;
            }
        },
        viewDetailOption(option) {
            let tooltip = '';
            for (let i in this.shortcutAssetManager) {
                if(option===i) {
                    tooltip+= `${this.shortcutAssetManager[i]} <br>`
                    break;
                }
            }
            return `<span>${tooltip}</span>`;
        }
    },
    watch:{
        nonEsg(val) {
            if (val) {
                this.basic.esg = false;
            } else {
                if (this.basic.esg === false) {
                    this.basic.esg = null;
                }
            }
        },
        nonEtf(val) {
            if (val) {
                this.basic.etf = false;
            }else {
                if (this.basic.etf === false) {
                    this.basic.etf = null;
                }
            }
        },
        clean:function (){
            this.cleanAll()
        },
        basic:{
            deep: true,
            //immediate: true,
            handler(){
                if (this.basic.esg) {
                    this.nonEsg = false;
                }
                if (this.basic.esg === false && this.nonEsg === false) {
                    this.basic.esg = null;
                    return;
                }
                if (this.basic.etf) {
                    this.nonEtf = false;
                }
                if (this.basic.etf === false && this.nonEtf === false) {
                    this.basic.etf = null;
                    return;
                }
                this.$store.dispatch("search/provisionalCall", {...this.basic})
                this.$emit("working-filter", true);
            }
        },
    },
    async mounted() {
        Object.assign(this.saveKeys, this.basic)
        Object.assign(this.basic, this.$store.state.search.filters)
        if (this.basic.esg == false) {
            this.nonEsg = true;
        }
        if (this.basic.etf == false) {
            this.nonEtf = true;
        }
        this.$store.dispatch("search/getCategories")
        
        this.$store.commit("search/SET_PROV_FILTERS", this.$store.state.search.filters)
    },
}
</script>
<style scoped lang="scss">
.risk-indicator-wrap{
    flex-flow: column;
    align-items: center;
}
.arrow-right {
  width: 0; 
  height: 0; 
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  
  border-left: 20px solid #4154ea;
}

.arrow-left {
  width: 0; 
  height: 0; 
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent; 
  border-right:20px solid #4154ea; 
}
.line {
    height: 4px;
    margin-top: 8px;
    max-width: 245px;
    width: 100%;
    background:linear-gradient(270deg, #4154ea 0%, #41bcea 100%);
   &.no-border {
    border: none;
    height: 0;
}
}
.btn-active::v-deep .control-label {
    background: #F08261;
    text-align: center;
    display: block;
    width: auto !important;
    color: #fff;
    border-radius: 3px;
    padding: 2px 0.75rem;
    text-transform: uppercase;
    font-weight: bold;
    margin-left: calc(0.75em - 1px);
}
.btn-passive::v-deep .control-label {
    text-align: center;
    display: block;
    width: auto !important;
    border-radius: 3px;
    padding: 2px 0.75rem;
    text-transform: uppercase;
    font-weight: bold;
    background-color: #afef97;
    color: rgb(54, 54, 54);
    margin-left: calc(0.75em - 1px);
}
.sustainability, .etf-options {
    .checkbox {
        flex: 1;
    }
} 
</style>
